module.exports = __webpack_public_path__ + "static/qh_7.1117b20a.jpg";